export default {
  LOADING_GET_CUSTOMER_ORDERS: 'LOADING_GET_CUSTOMER_ORDERS',
  SUCCESS_GET_CUSTOMER_ORDERS: 'SUCCESS_GET_CUSTOMER_ORDERS',
  ERROR_GET_CUSTOMER_ORDERS: 'ERROR_GET_CUSTOMER_ORDERS',

  LOADING_GET_CUSTOMER_TRADES: 'LOADING_GET_CUSTOMER_TRADES',
  SUCCESS_GET_CUSTOMER_TRADES: 'SUCCESS_GET_CUSTOMER_TRADES',
  ERROR_GET_CUSTOMER_TRADES: 'ERROR_GET_CUSTOMER_TRADES',

  RESET_CUSTOMER_ORDERS: 'RESET_CUSTOMER_ORDERS',

  LOADING_DELETE_ORDER: 'LOADING_DELETE_ORDER',
  SUCCESS_DELETE_ORDER: 'SUCCESS_DELETE_ORDER',
  ERROR_DELETE_ORDER: 'ERROR_DELETE_ORDER',

  ORDER_ID_IS_EDITING: 'ORDER_ID_IS_EDITING',

  SIGNALR_ORDER_OPENED: 'SIGNALR_INCOME/order-opened',

  SIGNALR_ORDER_UPDATED: 'SIGNALR_INCOME/order-updated',
  SPOT_ORDER_UPDATED_SUCCESS: 'SPOT_ORDER_UPDATED_SUCCESS',

  SIGNALR_ORDER_CLOSED: 'SIGNALR_INCOME/order-closed',

  LOADING_GET_LATEST_TRADE: 'LOADING_GET_LATEST_TRADE',
  SUCCESS_GET_LATEST_TRADE: 'SUCCESS_GET_LATEST_TRADE',
  ERROR_GET_LATEST_TRADE: 'ERROR_GET_LATEST_TRADE',
} as const;
